import { useQuery } from '@tanstack/react-query'
import { httpGetFinalReviewListingActivity } from '@/features/luxe-submissions/http/luxe-submissions.http'

export const FINAL_REVIEW_LISTING_ACTIVITY_QUERY_KEY =
	'final-review-listing-activity'

export const useGetFinalReviewListingActivity = (listingId: string) =>
	useQuery({
		queryKey: [FINAL_REVIEW_LISTING_ACTIVITY_QUERY_KEY, listingId],
		queryFn: () => httpGetFinalReviewListingActivity(listingId),
		enabled: !!listingId
	})
